"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.AllGatewayFileTypes = exports.ApiFileTypes = exports.FileTypes = void 0;
var FileTypes;
(function (FileTypes) {
    FileTypes["unknown"] = "UNKNOWN";
    FileTypes["price"] = "PRICE";
    FileTypes["rate"] = "RATE";
    FileTypes["priceAndRate"] = "PRICEANDRATE";
    FileTypes["accountMaster"] = "ACCTMSTR";
    FileTypes["investment"] = "HOLDING";
    FileTypes["ach"] = "TPACH";
    FileTypes["trade"] = "TRADE";
    FileTypes["custodianReconPosition"] = "MSCSPOSITION";
    FileTypes["custodianReconBalance"] = "TPPSOT";
    FileTypes["cashOut"] = "TPBFRD";
    FileTypes["cashIn"] = "TPDPOT";
    FileTypes["cashDisbursement"] = "TPDISB";
    FileTypes["cashTransfer"] = "TPMVCA";
    FileTypes["transactionActivity"] = "NWACTIVITY";
    FileTypes["custodianReconDividendActivity"] = "NWDIVIDEND";
    FileTypes["divDeclaration"] = "DIVDECLARATIONS";
    FileTypes["fundInformation"] = "FUNDINFORMATION";
    FileTypes["participantCountReport"] = "PARTICIPANTCOUNT";
    FileTypes["confirmation"] = "confirm";
    FileTypes["fundRules"] = "fundRules";
    FileTypes["distributionDeclarations"] = "distributionDeclarations";
    FileTypes["checkRegister"] = "CheckRegister";
    FileTypes["selfDirectedAccountCashTransferRequest"] = "SDMOVEMENT";
    FileTypes["selfDirectedAccountValue"] = "selfDirectedAccountValue";
    FileTypes["selfDirectedAccountCashTransferStatus"] = "selfDirectedAccountCashTransferStatus";
    FileTypes["selfDirectedAccountMapping"] = "selfDirectedAccountMapping";
    FileTypes["selfDirectedAccountPosition"] = "selfDirectedAccountPosition";
    FileTypes["bnyCashActivityFileBAI2"] = "bnyCashActivityFileBAI2";
    FileTypes["bnyCashBalanceFileBAI2"] = "bnyCashBalanceFileBAI2";
    FileTypes["bnyCheckRegister"] = "bnyCheckRegister";
    FileTypes["bnyCashDisbursement"] = "bnyCashDisbursement";
    FileTypes["bnyCheckDisbursement"] = "bnyCheckDisbursement";
    FileTypes["bnyCheckControl"] = "bnyCheckControl";
    FileTypes["bnyDeposit"] = "bnyDeposit";
    FileTypes["bnyAchWireStatusL2"] = "bnyAchWireStatusL2";
    FileTypes["bnyAchWireStatusL3"] = "bnyAchWireStatusL3";
    FileTypes["bnyPaidChecks"] = "bnyPaidChecks";
    FileTypes["bnyStopCheck"] = "bnyStopCheck";
})(FileTypes = exports.FileTypes || (exports.FileTypes = {}));
var ApiFileTypes;
(function (ApiFileTypes) {
    ApiFileTypes["securityMaster"] = "securityMaster";
    ApiFileTypes["etfDistributions"] = "etfDistributions";
})(ApiFileTypes = exports.ApiFileTypes || (exports.ApiFileTypes = {}));
exports.AllGatewayFileTypes = __spreadArray(__spreadArray([], Object.values(FileTypes), true), Object.values(ApiFileTypes), true);
